import { Box } from '@mui/material';
import { AgColor } from '../Styles/AgColor';
import AgTypography from '../Styles/AgTypography';
import CheckIcon from '@mui/icons-material/Check';
import { useIntl } from 'react-intl';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { CSSProperties } from 'react';
import AgLoadingButton from '../AgLoadingButton';

export interface itemsType {
  id: string;
  title: string;
  subTitle: string;
  isCompleted?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

const AgProgressBar = (
  {
    items,
    percent,
    forward,
    forwardDisabled,
    backward,
    backwardDisabled,
    btnClick,
    btnLabel,
    showBtn,
    disableBtn,
    isAddNewButtonLoading,
    sx
  }: {
    items: itemsType[];
    percent: number;
    forward?: Function;
    forwardDisabled?: boolean;
    backward?: Function;
    backwardDisabled?: boolean;
    btnClick?: Function;
    btnLabel: string;
    showBtn?: boolean;
    isAddNewButtonLoading?: boolean;
    sx?: CSSProperties;
    disableBtn?: boolean;
  }
) => {
  const messages = useIntl().formatMessage;
  const renderSteps = (stepNumber: number, item: itemsType) => {
    return (
      <Box
        key={stepNumber}
        onClick={item.onClick}
        sx={{
          width: `${90 / items.length}%`,
          maxWidth: '216px',
          minWidth: '143px',
          padding: '0px',
          gap: '16px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        }}
      >
        <Box sx={{ height: '34px' }}>
          <Box
            sx={{
              bgcolor: item.isActive ? AgColor.primaryLight : AgColor.primaryLight2,
              color: item.isActive ? AgColor.grey0 : AgColor.primaryLight,
              width: '32px',
              height: '32px',
              borderRadius: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {stepNumber}

          </Box>
          {item?.isCompleted && <Box sx={{
            width: '16px',
            height: '16px',
            bgcolor: AgColor.greenMain,
            borderRadius: '60px',
            display: 'flex',
            alignItems: 'center',
            zIndex: 10,
            justifyContent: 'center',
            position: 'relative',
            bottom: '12px',
            left: '20px'
          }}>
            <CheckIcon sx={{
              width: '12px',
              height: '12px',
              bgcolor: 'transparent',
              color: AgColor.grey0,
              borderRadius: '60px',
              zIndex: 100
            }} />
          </Box>}
        </Box>
        <Box
          sx={{
            height: 'fit-content',
            padding: '0px',
            position: 'relative',
            width: '100%'
          }}>
          <AgTypography
            contentStyle='AP.Assistive.Text.SemiBold' style={{ color: AgColor.grey9, lineHeight: '16px' }}
            component='p'>{item.title}</AgTypography>
          <AgTypography
            contentStyle='AP.Assistive.Text.Regular'
            style={{ color: AgColor.grey7, lineHeight: '16px', width: '100%' }}
            component='p'>{item.subTitle}</AgTypography>
        </Box>
      </Box>);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        borderRadius: '8px',
        border: `.75px solid ${AgColor.grey3}`,
        padding: '16px',
        gap: '16px',
        height: 'fit-content',
        alignItems: 'center',
        overflowY: 'auto',
        backgroundColor: AgColor.grey0,
        boxShadow: '0px 1px 2px 0px #0000000D',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1 0 auto',
          flexWrap: 'wrap',
          minWidth: '0',
          gap: '16px'
        }}
      >
        {items.map((i, index) => renderSteps(index + 1, i))}
      </Box>
      <Box
        sx={{
          float: 'right',
          minWidth: '194px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          justifyContent: 'end',
          alignItems: 'center',
          padding: '0px',
          height: 'fit-content'
        }}
      >
        <Box sx={{ padding: '0px', height: '34px', textAlign: 'right', flex: '1 1 auto' }}>
          <AgTypography style={{ color: percent === 100 ? AgColor.success2 : AgColor.warning2 }} contentStyle='AP.H3.Bold' component='p'>
            {percent > 100 ? 100 : percent}%
          </AgTypography>
          <AgTypography
            style={{ color:  percent === 100 ? AgColor.success2 : AgColor.warning2  }}
            sx={{ minWidth: '73px' }}
            contentStyle='AP.H5.Bold'
            component='p'
          >
            {messages({ id: 'OF_MANDATORY' })}
          </AgTypography>
        </Box>
        <Box sx={{ padding: '0px', display: 'flex', gap: '8px', alignItems: 'center' }}>
          <Box
            sx={{
              cursor: backwardDisabled? 'default' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '40px',
              height: '36px',
              border: `1px solid ${AgColor.grey3}`,
              borderRadius: '4px'
            }}
            onClick={() => backward && backward()}
          >
            <ArrowBackIcon sx={{ color: backwardDisabled ? AgColor.grey5 : AgColor.secondaryDark }} />
          </Box>
          <Box
            sx={{
              cursor: forwardDisabled ? 'default' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '40px',
              height: '36px',
              border: `1px solid ${AgColor.grey3}`,
              borderRadius: '4px'
            }}
            onClick={() => forward && forward()}
          >
            <ArrowForwardIcon sx={{ color: forwardDisabled ? AgColor.grey5 : AgColor.secondaryDark }} />
          </Box>
          {showBtn && <AgLoadingButton loading={isAddNewButtonLoading} style={{ height: '34px' }} label={btnLabel} onClick={() => btnClick && btnClick()} disabled={disableBtn} />}
        </Box>
      </Box>
    </Box>
  );
};

export default AgProgressBar;